import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Keys must match the backend TranslationDomain/Audience/Register enums.
const DOMAIN_OPTIONS = ['general', 'medical', 'legal', 'technical', 'marketing', 'academic', 'financial', 'government'];
const AUDIENCE_OPTIONS = ['general_public', 'children', 'business', 'technical_experts', 'patients', 'legal_professionals'];
const TONE_OPTIONS = ['formal', 'semiformal', 'casual', 'friendly', 'technical'];

const EMPTY_BRIEF = { domain: '', audience: '', tone: '', additional_context: '', terminology: '' };

// The optional brief for a translation, shared by document and scan uploads.
export function useTranslationBrief() {
  const [brief, setBrief] = useState(EMPTY_BRIEF);
  const context = Object.fromEntries(
    Object.entries(brief)
      .map(([key, value]) => [key, value.trim()])
      .filter(([, value]) => value),
  );
  return { brief, setBrief, context: Object.keys(context).length > 0 ? context : null };
}

function OptionSelect({ value, onChange, options, prefix, t }) {
  return (
    <select className="input" value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">{t('brief.notSet')}</option>
      {options.map((key) => (
        <option key={key} value={key}>{t(`brief.${prefix}.${key}`)}</option>
      ))}
    </select>
  );
}

export function TranslationBriefFields({ brief, setBrief }) {
  const { t } = useTranslation('chat');
  const set = (key) => (value) => setBrief({ ...brief, [key]: value });

  return (
    <details className="brief-details">
      <summary className="brief-summary">
        {t('brief.summary')}
        <span className="brief-summary-hint">{t('brief.summaryHint')}</span>
      </summary>
      <div className="brief-fields">
        <div className="brief-field">
          <label>{t('brief.domain')}</label>
          <OptionSelect value={brief.domain} onChange={set('domain')} options={DOMAIN_OPTIONS} prefix="domainOpts" t={t} />
        </div>
        <div className="brief-field">
          <label>{t('brief.audience')}</label>
          <OptionSelect value={brief.audience} onChange={set('audience')} options={AUDIENCE_OPTIONS} prefix="audienceOpts" t={t} />
        </div>
        <div className="brief-field">
          <label>{t('brief.tone')}</label>
          <OptionSelect value={brief.tone} onChange={set('tone')} options={TONE_OPTIONS} prefix="toneOpts" t={t} />
        </div>
        <div className="brief-field brief-field-full">
          <label>{t('brief.additionalContext')}</label>
          <textarea
            className="input"
            rows={2}
            value={brief.additional_context}
            onChange={(e) => set('additional_context')(e.target.value)}
            placeholder={t('brief.additionalContextPh')}
          />
        </div>
        <div className="brief-field brief-field-full">
          <label>{t('brief.terminology')}</label>
          <textarea
            className="input"
            rows={2}
            value={brief.terminology}
            onChange={(e) => set('terminology')(e.target.value)}
            placeholder={t('brief.terminologyPh')}
          />
        </div>
      </div>
    </details>
  );
}
